export const userSelector = (state: any) => state?.userReducer?.user;

export const reloadContactCreditSelector = (state: any) =>
  state?.userReducer?.reloadContactCredit;
